/* «تم التأكيد قبل X يوم» -- from availability_confirmed_at, or nothing.
 *
 * HONEST SIGNALS: a listing nobody has confirmed draws NOTHING here. Not a dash,
 * not «غير مؤكد» -- a missing confirmation is the normal state of every listing
 * that predates the lifecycle, and labelling it would read as an accusation. A
 * timestamp in the future (clock skew) is treated as absent rather than shown as
 * a negative number of days. The words are site texts (v3.lifecycle.*). */
import { fill } from "@/v3/strings";

export function confirmedText(
  iso: string | null | undefined,
  s: { lifecycle: { confirmedToday: string; confirmedAgo: string } },
  now: number = Date.now(),
): string | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t) || t > now) return null;
  const days = Math.floor((now - t) / 86400000);
  return days === 0 ? s.lifecycle.confirmedToday : fill(s.lifecycle.confirmedAgo, { n: String(days) });
}
